// React
import { Banner, Flex } from '@pega/cosmos-react-core';
import React from 'react';
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { AgenticLoaderPreview } from '../../../../../interfaces/chat';
import { appState } from '../../../../../interfaces/common';
import { useSupportedLanguagesSelector } from '../../../../../redux/selectors';
import AgenticTypingIndicator from './AgenticTypingIndicator';
import TextMessage from './TextMessage';

const ChatHistoryContainer = styled.div(
  () =>
    css`
      overflow: auto;
      background-color: #ffff;
      height: 100%;
    `,
);

const ChatBanner = styled.div(
  () =>
    css`
      margin: 10px;
    `,
);

interface ConversationProps {
  selectedThemeColor: string;
  agenticPreview?: AgenticLoaderPreview | null;
}

const Conversation: React.FC<ConversationProps> = ({ selectedThemeColor, agenticPreview }) => {
  const {
    chatInfo: {
      enableAvatars,
      showSpecialNote = false,
      specialNote = {},
      enableMultiPhaseLoader,
      dynamicPhrases,
      isAgenticMessaging,
    },
  } = useSelector((state: appState) => {
    return {
      chatInfo: state.chatInfo,
    };
  });

  const isLoaderEnabled = agenticPreview ? agenticPreview.enabled : enableMultiPhaseLoader;
  const loaderPhrases = agenticPreview ? agenticPreview.phrases : dynamicPhrases;

  const languagesSupportedByConsumer = useSupportedLanguagesSelector();
  const firstLanguage = languagesSupportedByConsumer?.[0];
  const defaultLanguage = firstLanguage ? firstLanguage : 'en';

  return (
    <>
      <Flex as={ChatHistoryContainer} style={{ padding: enableAvatars ? '8px 5px' : '8px 16px' }}>
        {showSpecialNote && (
          <Flex as={ChatBanner}>
            <Banner id="special_note" variant={'info'} messages={[specialNote[defaultLanguage]]} onDismiss={() => {}} />
          </Flex>
        )}
        <TextMessage messageFrom="bot" message="bot_message" csrName="" />
        <TextMessage messageFrom="user" message="user_message" selectedThemeColor={selectedThemeColor} csrName="cx" />
        {isAgenticMessaging && isLoaderEnabled ? (
          <AgenticTypingIndicator phrases={loaderPhrases} selectedThemeColor={selectedThemeColor} />
        ) : (
          <TextMessage messageFrom="csr" csrName="John Doe" message="csr_message" />
        )}
      </Flex>
    </>
  );
};

export default Conversation;
